import MemberRequest from "../../../../Controllers/MemberRequest";

function getResult(data) {
  let res=false;
  if (data.hasOwnProperty("getCityData")) {
    res = data.getCityData;
    if(res=== null) res=false;
  }
  return res;
}

const sendGet = async function (ostanId,pageAlerts) {
  let res=false;
  let req=new MemberRequest();
  req._pageAlerts=pageAlerts;
  if(!Boolean(ostanId)) ostanId=0;
  req.query=`{getCityData(ostanId:${ostanId}){city{id,name}}}`;
  res = await req.send(getResult);
  return res;
};

export default async function getCityDataApi(ostanId,pageAlerts) {
  return await sendGet(ostanId,pageAlerts);
}
